import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { ChartSignal } from 'api/traps/types';

export const getAnalyticsSRBMHeatMapChart = async (slug: string, start_datetime: string, end_datetime: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/traps/charts/bait-activation-signals/object/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      start_datetime,
      end_datetime,
    },
  });
  return data.data as ChartSignal[];
};
